const serverUrl = 'https://newbiolabs-api.ocllis.com/';

export const environment = {
  production: true,
  aiEnabled: false,
  cryptoPassphrase: '42b9b632-b845-4f0c-8c2f-ab886466da8c',
  frontendUrl: 'https://newbiolabs.ocllis.com/',
  fusionAuth: {
    apiUrl: 'https://authprovider.ocllis.com/api',
    applicationId: '577cfb24-da05-4e76-b9d3-0b68d7cfff08',
    apiKey: 'tp5DevA_yavJkxwsEXi5wv9AHfKtKHdTmy7tIXiCbXi0h5rYTBCZdldO',
    tenantId: '85c75a3c-178c-4a48-ba13-353458630b31'
  },
  portalBackend: {
    serverUrl,
    apiUrl: `${serverUrl}api`,
  },
  aiAnalysis: {
    enabled: false,
    apiUrl: 'https://****portal-analyzer.ocllis.com',
    enabledRoles: ['*']
  },
  aiCommands: {
    enabled: false,
    areas: ['missing-info'],
    apiUrl: 'https://***portal-voice-analyzer.ocllis.com'
  },
  resultExport: false,
  sentry: {
    dns: 'https://56d44084ddbc4ecd8fd5469bb641522b@o968794.ingest.sentry.io/5920050',
  },
  allowCreateRequisitionWithMissingBillingInfo: true,
  allowCreateRequisitionWithMissingDiagnoses: true,
  allowCreateRequisitionWithMissingSignature: true,
  alternativeRequisitionForm: false,
};
